import {
  getCurrentPageIdentifier,
  getCurrentThemeKey,
  getLoadedLanguage,
} from './mainConfig';

export default {
  getCurrentPageIdentifier,
  getLoadedLanguage,
  getCurrentThemeKey,
};
